import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IConfirmRemovedAddonsActionParams, IAlreadyAddonsForPassenger } from "../../../Orchestrator/Types/Interface/IAddOns";

export class ConfirmRemovedAddonsAction extends BaseAction<
  IDefaultActionResult,
  IConfirmRemovedAddonsActionParams
> {
  override async run(): Promise<IDefaultActionResult> {
    const actionResult: IDefaultActionResult = {
      data: null,
      message: "",
      status: "fail",
    };
    try {
      let { addonsPassengerList = [] } = this.params!
      /**
       * Calculate all the uncheck addons means refund addons
      */
      if (addonsPassengerList.length > 0) {
        const alreadyAddonsLegPassenger: any = getRecoilStateValue("alreadyAddonsLegPassengerAtom")
        let allWayAddons: IAlreadyAddonsForPassenger[] = []
        if (alreadyAddonsLegPassenger) {
          allWayAddons = [
            ...(alreadyAddonsLegPassenger["outbound"] || []),
            ...(alreadyAddonsLegPassenger["inbound"] || []),
          ];
        }
        // Scope the diff to legs the caller actually confirmed. Without this,
        // addons on legs NOT in addonsPassengerList (e.g. the other leg of a
        // round-trip that the user didn't touch) fall into the "not in
        // keptSet" filter and get marked as removed — which then causes
        // PersistAddonsOnConfirmAction to DELETE those unrelated ancillaries
        // from the booking. Symptom: confirming addons on one leg wipes the
        // other leg's already-booked addons.
        const confirmedLegIds = new Set(
          (addonsPassengerList || [])
            .map(l => l?.legId)
            .filter((id): id is string => !!id)
        );
        const allWayAddonsForConfirmedLegs = allWayAddons.filter(
          item => !!item?.legId && confirmedLegIds.has(item.legId)
        );

        const keptSet = new Set();
        (addonsPassengerList || []).forEach(leg => {
          leg.addonsPassenger.forEach(passenger => {
            Object.values(passenger?.addonItem || {}).forEach((item: any) => {
              keptSet.add(`${leg.legId}-${passenger.passengerId}-${item.label.replaceAll(" ", "_").toLowerCase()}`);
            });
          });
        });
        const removedAddons: IAlreadyAddonsForPassenger[] = (allWayAddonsForConfirmedLegs || []).filter((item: any) => {
          const key = `${item.legId}-${item.passengerId}-${item.addonName.replaceAll(" ", "_").toLowerCase()}`;
          return !keptSet.has(key);
        });

        updateRecoilState("manageAddonsRemovedAddonsAtom", removedAddons)
        actionResult.status = "success";
        actionResult.data = removedAddons
      }
    } catch (error: any) {
      console.error("error", error);
      actionResult.message = error.message;
    } finally {
      return actionResult;
    }
  }
}

export const confirmRemovedAddonsAction = new ConfirmRemovedAddonsAction();
